import { TextLabel } from '@core/components/Inputs';
import { DataBR } from '@format';
import { Grid, Tooltip } from '@material-ui/core';
import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';

const VisualizacaoTransferencia = ({ lancamento, exibirTooltipSemCorrespondencia }) => {
  const tooltipSemCorrespondencia =
    'Este é um lançamento que já foi baixado no sistema, mas que ainda não possui outro ' +
    'semelhante nos extratos importados para que seja conciliado.';

  return (
    <Grid container spacing={3}>
      {exibirTooltipSemCorrespondencia && (
        <Grid item xs={12} style={{ textAlign: 'end' }}>
          <Tooltip title={tooltipSemCorrespondencia} placement="right-end">
            <button type="button" onClick={() => {}}>
              <FaInfoCircle size={18} style={{ color: '#f2994a' }} />
            </button>
          </Tooltip>
        </Grid>
      )}
      <Grid item xs={6}>
        <TextLabel id="lancamento.contaOrigem" label="Conta origem" value={lancamento?.origem?.descricao} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel id="lancamento.contaDestino" label="Conta destino" value={lancamento?.destino?.descricao} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel id="lancamento.categoria" label="Descrição" value={lancamento?.descricao} />
      </Grid>
      <Grid item xs={6} />
      <Grid item xs={6}>
        <TextLabel id="lancamento.valor" label="Valor (R$)" value={getCurrencySemSinalMonetario(lancamento?.valor)} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel id="lancamento.dataPagamento" label="Data" value={DataBR(lancamento?.data)} />
      </Grid>
    </Grid>
  );
};

export default VisualizacaoTransferencia;
